import { render } from "./SortOptions.vue?vue&type=template&id=63efbcc8&scoped=true"
import script from "./SortOptions.vue?vue&type=script&lang=js"
export * from "./SortOptions.vue?vue&type=script&lang=js"

import "./SortOptions.vue?vue&type=style&index=0&id=63efbcc8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63efbcc8"]])

export default __exports__